import React, { FC } from 'react'
import classnames from 'classnames/bind'
import Icon, { IconProps } from '../../../elementals/icon'
import PopupTooltip from '../../../overlays/popupTooltip'
import styles from '../styles.scss'
const cx = classnames.bind(styles)

type FieldTooltipProps = {
  showAnchor?: boolean
  helpContent?: React.ReactNode
  on?: string
  label?: string
  error?: string
  iconStyle: IconProps['iconStyle']
  elmId?: string
  showError?: boolean
}

const FieldTooltip: FC<FieldTooltipProps> = (props: FieldTooltipProps) => {
  const {
    on = 'hover',
    elmId,
    showError,
    helpContent,
    label,
    error,
    showAnchor = true,
    iconStyle = 'light',
  } = props

  const iconInfo: {
    name: string
    iconStyle: IconProps['iconStyle']
    color: string
  } = !showError
    ? { name: 'info-circle', iconStyle, color: 'gray' }
    : { name: 'exclamation-circle', iconStyle, color: 'error' }

  return (
    <div>
      {!!showError && (
        <label
          data-elm-id={`${elmId}_error_tooltip`}
          className={cx('tooltip-error')}
        >
          {error}
        </label>
      )}

      {showAnchor && (
        <PopupTooltip
          data-elm-id={`${elmId}_tooltip_content`}
          on={on}
          trigger={
            <Icon data-elm-id={`${elmId}_tooltip`} fitted {...iconInfo} />
          }
          content={helpContent || label}
          position='top right'
          popperModifiers={
            [
              {
                name: 'flip',
                options: {
                  fallbackPlacements: ['top', 'bottom'],
                },
              },
            ] as any
          }
          offset={0}
          horizontalOffset={0}
          verticalOffset={0}
        />
      )}
    </div>
  )
}

export default FieldTooltip
